import { useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const { logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    logout();
    nav("/login", { replace: true });
  }, [logout, nav]);

  return null; // nada que mostrar
}
